import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import { Table, TableRow } from "../../../components/Table";
import { GetMerchantStatePayInMeta, GetStatePayInMeta, useMerchantStatePayInMeta, useStatePayInMeta } from "../../../redux/slices/statePayInMetaSlice";
import StateBanks from "./StateBanks";
import AddStateBankModal from "../../../components/Custom/Modals/AddStateBankModal/AddStateBankModal";
import MerchantStateView from "./MerchantStateView";
import { useRole } from "../../../redux/slices/authSlice";

const StatePayInMeta = () => {
    const dispatch = useDispatch();
    const role = useRole("State Wise Meta");
    const data = useStatePayInMeta();
    const merchantData = useMerchantStatePayInMeta();
    const [tableData, setTableData] = useState([]);
    const [merchantTableData, setMerchantTableData] = useState([]);
    const [filterColumns, setFilterColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);

    const columns = [
        {
            title: "State Name",
            name: "stateName",
        },
        {
            title: "Total Banks",
            name: "count",
            Cell: (row) => row?.banks?.length || 0
        }
    ];

    const merchantColumns = [
        {
            title: "Merchant Name",
            name: "merchantName",
        },
        {
            title: "Total States",
            name: "count",
            Cell: (row) => Object.keys(row?.states || {}).length || 0
        }
    ];

    const onGetData = async () => {
        try {
            setIsLoading(true);
            await dispatch(GetStatePayInMeta()).unwrap();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const onGetMerchantData = async () => {
        try {
            setIsLoading(true);
            await dispatch(GetMerchantStatePayInMeta()).unwrap();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (currentTab === 0) {
            setFilterColumns(columns.map(c => c.name));
            onGetData();
        } else {
            setFilterColumns(merchantColumns.map(c => c.name));
            onGetMerchantData();
        }
    }, [currentTab]);

    useEffect(() => {
        if (data?.data && typeof data?.data === 'object') {
            const formatted = Object.entries(data.data).map(([key, val]) => ({
                stateName: key,
                banks: val
            }));
            setTableData(formatted);
        }
    }, [data]);

    useEffect(() => {
        if (merchantData?.data && typeof merchantData?.data === 'object') {
            const formatted = Object.entries(merchantData.data).map(([key, val]) => ({
                merchantName: key,
                states: val
            }));
            setMerchantTableData(formatted);
        }
    }, [merchantData]);


    const tabsData = [
        { title: "State-wise" },
        { title: "Merchant-wise" },
    ];

    if (!role.includes("state-wise-meta")) {
        return null;
    }

    return (
        <div className="merchant-main-div">
            <Card>
                <CardHeader className="d-flex flex-column align-items-start">
                    <div className="d-flex align-items-center w-100 justify-content-between">
                        <h4 className="main-title"><b>State-wise Meta</b></h4>
                        <div className="d-flex align-items-center gap-1">
                            <div className="d-flex button-space">
                                {tabsData.map((tab, index) => (
                                    <Button
                                        key={index}
                                        className={currentTab === index ? "btn-primary" : "filterbtn"}
                                        color={currentTab === index ? "btn-primary" : ""}
                                        onClick={() => setCurrentTab(index)}
                                    >
                                        {tab.title}
                                    </Button>
                                ))}
                            </div>
                            {role.includes("add-state-wise-meta") ? (
                                <Button color="primary" onClick={() => setIsAddModalOpen(true)}>
                                    Add Bank
                                </Button>
                            ) : null}
                        </div>
                    </div>
                </CardHeader>
                {currentTab === 0 ? (
                    <Table
                        columns={columns}
                        filterColumns={filterColumns}
                        data={tableData}
                        isData={!!tableData.length}
                        count={tableData.length}
                        isLoading={isLoading}
                        isExpandable={true}
                    >
                        {tableData.map((val, i) => (
                            <TableRow
                                key={i}
                                columns={columns}
                                filterColumns={filterColumns}
                                item={val}
                                isExpandable={true}
                            >
                                <StateBanks banks={val.banks} onGet={onGetData} />
                            </TableRow>
                        ))}
                    </Table>
                ) : (
                    <Table
                        columns={merchantColumns}
                        filterColumns={filterColumns}
                        data={merchantTableData}
                        isData={!!merchantTableData.length}
                        count={merchantTableData.length}
                        isLoading={isLoading}
                        isExpandable={true}
                    >
                        {merchantTableData.map((val, i) => (
                            <TableRow
                                key={i}
                                columns={merchantColumns}
                                filterColumns={filterColumns}
                                item={val}
                                isExpandable={true}
                            >
                                <MerchantStateView states={val.states} onGet={onGetMerchantData} />
                            </TableRow>
                        ))}
                    </Table>
                )}
            </Card>
            <AddStateBankModal
                isOpen={isAddModalOpen}
                onHide={() => setIsAddModalOpen(false)}
            />
        </div>
    );
};
export default StatePayInMeta;
